import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

interface SelectFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
  error?: string;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  options,
  placeholder = 'Selecione...',
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger
          className={cn(error ? 'border-red-500 focus:border-red-500' : '')}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
